<template>
  <button class="sns-button-wrapper" @click="onClickKakaoLogin">
    <slot>
      <sns-logo-circle sns-name="kakao" :width="44" :height="44" />
    </slot>
    <span class="a11y-hidden">카카오로 로그인</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { setLibFile } from '@/common/plugins/sns.lib'
  import { onMounted } from 'vue'
  import utils from '@/common/util/utils'
  import { useRoute } from 'vue-router/composables'

  const props = defineProps({
    useMemberWeb: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['success', 'fail'])
  const route = useRoute()

  const loginSuccessCallback = (token) => {
    emit('success', { token })
  }

  const loginFaildCallback = (err) => {
    emit('fail', err)
  }

  const getKakaoToken = () => {
    Kakao.Auth.login({
      success: function () {
        loginSuccessCallback(Kakao.Auth.getAccessToken())
      },
      fail: function (error) {
        loginFaildCallback(error)
      },
    })
  }

  const onClickKakaoLogin = () => {
    if (props.useMemberWeb) {
      const loginUrl = utils.login.getMemberSnsLoginUrl({
        type: 'kakao',
        callback: location.href,
      })
      location.href = loginUrl
      return
    }
    getKakaoToken()
  }

  const sdkInit = () => {
    window.kakaoAsyncInit = function () {
      Kakao.init('30fc7e17b5c56a0ca1e861643292c203')
    }
    setLibFile(
      document,
      'script',
      'kakao-jssdk',
      '//developers.kakao.com/sdk/js/kakao.min.js',
    )
  }

  onMounted(() => {
    const { type, token } = route.query
    if (type === 'kakao') {
      if (token) {
        emit('success', { token })
      } else {
        emit('fail', { message: 'Failed to get token' })
      }
    }
    if (props.useMemberWeb) {
      return
    }
    sdkInit()
  })
</script>
